import session from '../plugins/session'

export function salvarDadosHierarquia (data) {
  if (data) {
    const hierarquia_comercial = data['hierarquia_comercial']

    if (hierarquia_comercial) {
      session.set({
        hierarquia_comercial
      })
    }
  }
}
